/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { LogLevel } from 'apps/console-core/src/Services/logging';

/**
 * Get the corresponding type for the log level.
 */
export const getLogLevel = (level: LogLevel): string => {
  switch (level) {
    case LogLevel.ERROR:
      return `error`;
    case LogLevel.WARNING:
      return `warning`;
    case LogLevel.INFO:
    default:
      return `info`;
  }
};
